import React from "react";
import PropTypes from "prop-types";
import SmartText from "../../utils/TextHandler";
import SmartImage from "../../utils/ImageHandler";
import Link from "../Global/Link";

const CardContact = (props) => {
  const { item, size } = props;

  return (
    <div
      className={`d-flex flex-column brand-shadow brand-radius p-4 p-md-5 h-100`}
    >
      {item.title && <h3 className="fw-bold mb-3">{item.title}</h3>}
      {item.body && <SmartText>{item.body}</SmartText>}
      {item.link && (
        <div>
          <Link to={item.link} button icon>
            {item.button}
          </Link>
        </div>
      )}
    </div>
  );
};

export default CardContact;

CardContact.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CardContact.defaultProps = {
  settings: null,
};
